var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.69206 7.5H6.00016C5.06674 7.5 4.59968 7.5 4.24316 7.68166C3.92956 7.84144 3.67478 8.09623 3.51499 8.40983C3.33333 8.76635 3.33333 9.23341 3.33333 10.1668V14.8335C3.33333 15.7669 3.33333 16.2334 3.51499 16.5899C3.67478 16.9035 3.92956 17.1587 4.24316 17.3185C4.59934 17.5 5.06585 17.5 5.99745 17.5H14.0026C14.9342 17.5 15.4 17.5 15.7562 17.3185C16.0698 17.1587 16.3254 16.9035 16.4852 16.5899C16.6667 16.2337 16.6667 15.7679 16.6667 14.8363V10.1641C16.6667 9.23249 16.6667 8.766 16.4852 8.40983C16.3254 8.09623 16.0698 7.84144 15.7562 7.68166C15.3996 7.5 14.9336 7.5 14.0002 7.5H12.3074M7.69206 7.5H12.3074M7.69206 7.5C7.58585 7.5 7.5 7.4139 7.5 7.30769V5C7.5 3.61929 8.61929 2.5 10 2.5C11.3807 2.5 12.5 3.61929 12.5 5V7.30769C12.5 7.4139 12.4137 7.5 12.3074 7.5",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPrivacy);
export default __webpack_public_path__ + "static/media/nav-privacy.afb369745f763d7b65cf03b52fea8570.svg";
export { ForwardRef as ReactComponent };